var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33258 2.72794C7.48487 1.32365 4.83772 1.46493 3.15087 3.15178C1.46402 4.83863 1.32274 7.48578 2.72704 9.33348L9.33258 2.72794ZM10.2417 3.63708L3.63617 10.2426C5.48388 11.6469 8.13103 11.5056 9.81788 9.81878C11.5047 8.13193 11.646 5.48479 10.2417 3.63708ZM2.24173 2.24264C4.58488 -0.100505 8.38387 -0.100505 10.727 2.24264C13.0702 4.58579 13.0702 8.38478 10.727 10.7279C8.38387 13.0711 4.58488 13.0711 2.24173 10.7279C-0.101411 8.38478 -0.101411 4.58579 2.24173 2.24264Z",
    fill: "#E26982"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.325e063b.svg";
export { ForwardRef as ReactComponent };